var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssistantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    id: "svg841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.007198,
    cy: 40.007198,
    r: 40.007198,
    fill: "#f2f4f7",
    id: "circle833"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g852",
    transform: "translate(11.765461,12.240168)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 29.6948,13.6641 c -4.944,-0.0071 -9.5026,2.6687 -11.9065,6.9889 -2.404,4.3202 -2.2747,9.6045 0.3376,13.802 l -3.9999,8.4007 8.3994,-4.0012 c 4.9121,3.0553 11.2182,2.6751 15.7276,-0.9482 4.5095,-3.6234 6.2389,-9.6996 4.3131,-15.1544 -1.9257,-5.4549 -7.0865,-9.0987 -12.8713,-9.0878 z",
    stroke: "#e60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 29.6955,33.3203 c -0.2687,0 -0.4865,0.2178 -0.4865,0.4865 0,0.2687 0.2178,0.4866 0.4865,0.4866 0.2687,0 0.4865,-0.2179 0.4865,-0.4866 0,-0.2687 -0.2178,-0.4865 -0.4865,-0.4865",
    stroke: "#e60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.8018,25.3405 c 0,-2.1497 1.7426,-3.8923 3.8922,-3.8923 2.1496,0 3.8922,1.7426 3.8922,3.8923 0,2.1496 -1.7426,3.8922 -3.8922,3.8922",
    stroke: "#e60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path839"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantIcon);
export default __webpack_public_path__ + "static/media/assistant-icon.13c7ab1a12d59272d750cd9c1b1bf43d.svg";
export { ForwardRef as ReactComponent };